module.exports = __webpack_public_path__ + "img/thumb_Untitled.a4abe357.jpg";